var map = {
	"./amdocs.en.md": 4996,
	"./amdocs.ru.md": 462,
	"./edu.en.md": 2290,
	"./edu.ru.md": 2093,
	"./freelance.en.md": 6087,
	"./freelance.ru.md": 6990,
	"./isdk.en.md": 8293,
	"./isdk.ru.md": 4759,
	"./s4ab.en.md": 9198,
	"./s4ab.ru.md": 9411,
	"./stecpoint.en.md": 1307,
	"./stecpoint.ru.md": 3313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7210;